import { render, staticRenderFns } from "./SettingMetadata.vue?vue&type=template&id=671ca8f5&scoped=true&"
import script from "./SettingMetadata.vue?vue&type=script&lang=js&"
export * from "./SettingMetadata.vue?vue&type=script&lang=js&"
import style0 from "./SettingMetadata.vue?vue&type=style&index=0&id=671ca8f5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671ca8f5",
  null
  
)

export default component.exports